<!--
Author: lijiawen
Date: 2021-03-17
Desc: 国家省市县组件
 -->
<template>
    <div>
        <div v-if="countryLayout == 'open'">
            <el-form-item label="国家/地区：" prop="country">
                <el-select
                    v-model="addrObj.country"
                    filterable
                    :placeholder="hideFunc ? '' : '国家'"
                    style="width: 120px !important"
                    :disabled="hideFunc"
                    v-on:change="qryProvince"
                >
                    <el-option
                        v-for="item in countryList"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-show="!isChina" label="省份：" prop="country">
                <el-select
                    v-model.trim="addrObj.province"
                    filterable
                    :placeholder="hideFunc ? '' : '省份'"
                    style="width: 120px !important"
                    :disabled="hideFunc || isChina"
                    v-on:change="qryCitys"
                >
                    <el-option
                        v-for="item in provinceList"
                        :key="item.subitem"
                        :label="item.subitemname"
                        :value="item.subitem"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-show="!isChina" label="市：" prop="country">
                <el-select
                    v-model.trim="addrObj.city"
                    filterable
                    :placeholder="hideFunc ? '' : '市'"
                    style="width: 120px !important"
                    :disabled="hideFunc || isChina"
                    v-on:change="qryCounty"
                >
                    <el-option
                        v-for="item in cityList"
                        :key="item.cityname"
                        :label="item.cityname"
                        :value="item.cityid"
                    />
                </el-select>
            </el-form-item>
            <el-form-item v-show="!isChina" label="县/区：" prop="country">
                <el-select
                    v-model.trim="addrObj.county"
                    filterable
                    :placeholder="hideFunc ? '' : '县/区'"
                    style="width: 180px !important"
                    :disabled="hideFunc || isChina"
                    v-on:change="getCounty"
                >
                    <el-option
                        v-for="item in countyList"
                        :key="item.countyname"
                        :label="item.countyname"
                        :value="item.countyid"
                    />
                </el-select>
            </el-form-item>
        </div>

        <el-form-item
            v-else
            label="国家-省-市-县/区:"
            prop="country"
            :class="{ required: required }"
        >
            <el-select
                v-model="addrObj.country"
                filterable
                :placeholder="hideFunc ? '' : '国家'"
                :style="selectWdiht"
                :disabled="hideFunc"
                v-on:change="qryProvince"
            >
                <el-option
                    v-for="item in countryList"
                    :key="item.subitem"
                    :label="item.subitemname"
                    :value="item.subitem"
                />
            </el-select>
            <el-select
                v-show="!isChina"
                v-model.trim="addrObj.province"
                filterable
                :placeholder="hideFunc ? '' : '省份'"
                :style="selectWdiht"
                :disabled="hideFunc || isChina"
                v-on:change="qryCitys"
            >
                <el-option
                    v-for="item in provinceList"
                    :key="item.subitem"
                    :label="item.subitemname"
                    :value="item.subitem"
                />
            </el-select>
            <el-select
                v-show="!isChina"
                v-model.trim="addrObj.city"
                filterable
                :placeholder="hideFunc ? '' : '市'"
                :style="selectWdiht"
                :disabled="hideFunc || isChina"
                v-on:change="qryCounty"
            >
                <el-option
                    v-for="item in cityList"
                    :key="item.cityname"
                    :label="item.cityname"
                    :value="item.cityid"
                />
            </el-select>
            <el-select
                v-show="!isChina"
                v-model.trim="addrObj.county"
                filterable
                :placeholder="hideFunc ? '' : '县/区'"
                :style="selectWdiht"
                :disabled="hideFunc || isChina"
                v-on:change="getCounty"
            >
                <el-option
                    v-for="item in countyList"
                    :key="item.countyname"
                    :label="item.countyname"
                    :value="item.countyid"
                />
            </el-select>
        </el-form-item>
    </div>
</template>
<script>
import util from "@/util";
export default {
    name: "CountryCitySelect",
    props: {
        value: {
            type: Object,
            default: () => {
                return null;
            }
        },
        countryLayout: {
            type: String,
            default: "open"
        },
        hideFunc: {
            type: Boolean,
            default: () => {
                return false;
            }
        },
        selectWdiht: {
            type: String,
            default: "width: 120px !important"
        }
    },
    data() {
        return {
            countryList: "",
            provinceList: this.$cache.getDict(this.$const.DICT.PROVINCE),
            cityList: this.$cache.get("address")["citylists"][this.value.province] || [],
            countyList: this.$cache.get("address")["countylists"][this.value.city] || [],
            cityListObj: this.$cache.get("address")["citylists"] || {},
            countyListObj: this.$cache.get("address")["countylists"] || {},
            addrObj: {
                country: this.$const.CN,
                province: "",
                city: "",
                county: "",
                address: ""
            },
            required: false,
            selectedProvince: "",
            selectedCity: "",
            selectedCounty: "",
            selectedAddress: "",
            hasCounties: true,
            isChina: false
        };
    },
    computed: {},
    watch: {
        "value.country"(val) {
            this.addrObj = Object.assign({}, this.value);
        },
        "value.province"(val) {
            this.addrObj = Object.assign({}, this.value);
        }
    },
    mounted() {
        this.addrObj = Object.assign({}, this.value);
        let required = this.$vnode.data.attrs["required"];
        if (required === "" || required === "true") {
            // 父组件有required属性，required="true"|| required
            this.required = true;
        }
        if (!this.$util.isEmpty(this.value.city) && !this.countyList) {
            this.hasCounties = false;
        }
        const _country = this.$cache.getDict(this.$const.DICT.COUNTRY, undefined, true);
        let _y = [];
        let _z = [];
        for (let i in _country) {
            if (
                _country[i].subitem === "CN" ||
                _country[i].subitem === "HK" ||
                _country[i].subitem === "MO" ||
                _country[i].subitem === "TW"
            ) {
                if (_country[i].subitemname.indexOf("中国") === -1) {
                    _country[i].subitemname = "中国" + _country[i].subitemname;
                }
                if (_country[i].subitem === "CN") {
                    _z.unshift(_country[i]);
                } else {
                    _z.push(_country[i]);
                }
                continue;
            }
            _y.push(_country[i]);
        }
        this.countryList = _z.concat(_y);
        this.addrObj.country = this.addrObj.country || this.$const.CN;
        if (this.addrObj.country != "CN") {
            this.isChina = true;
        }
    },
    methods: {
        clearData(items, excludeItem) {
            let defaultItems = ["city", "county"];
            if (!!items || excludeItem) {
                (items || defaultItems).forEach((item) => {
                    // 没传items默认清空所有除了excludeItem
                    if (item !== excludeItem) {
                        this.addrObj[item] = "";
                    }
                });
                this.$emit("input", this.addrObj);
                return;
            }
            this.clearData("", "province"); // 清空所有数据，除了国家
        },
        changeProvince: function () {
            this.hasCounties = true;
            this.clearData();
        },
        qryProvince: function (selectedCountry) {
            this.addrObj.country = selectedCountry;
            if (selectedCountry == "MO") {
                this.addrObj.province = "820000";
                this.addrObj.city = "820000";
                this.addrObj.city = "820000";
                this.qryCitys();
                this.addrObj.address = this.getAddress();
                this.$emit("input", this.addrObj);
                this.isChina = true;
            } else if (selectedCountry == "CN") {
                this.addrObj.address = this.getAddress();
                this.$emit("input", this.addrObj);
                this.isChina = false;
            } else if (selectedCountry == "TW") {
                this.addrObj.province = "710000";
                this.qryCitys();
                this.addrObj.city = "710000";
                this.addrObj.city = "710000";
                this.addrObj.address = this.getAddress();
                this.$emit("input", this.addrObj);
                this.isChina = true;
            } else if (selectedCountry == "HK") {
                this.addrObj.province = "810000";
                this.qryCitys();
                this.addrObj.city = "810000";
                this.addrObj.address = this.getAddress();
                this.$emit("input", this.addrObj);
                this.isChina = true;
            } else {
                this.provinceList = this.$cache.getDict(this.$const.DICT.PROVINCE);
                this.addrObj.address = this.getAddress();
                this.$emit("input", this.addrObj);
                this.isChina = true;
            }
        },
        qryCitys: function (selectedProvince) {
            if (this.addrObj.country == "CN") {
                this.addrObj.city = "";
                this.addrObj.county = "";
            }
            this.hasCounties = true;
            //                this.selectedProvince = selectedProvince.subitemname;
            this.cityList = this.cityListObj[this.addrObj.province];
            this.provinceList.forEach((item) => {
                if (item["subitem"] == selectedProvince) {
                    this.selectedProvince = item["subitemname"];
                }
            });
            // this.clearData(["city","county"]);
            this.matchCityCounty(this.cityList, "city");
            this.addrObj.address = this.getAddress();
            this.$emit("input", this.addrObj);
        },
        qryCounty: function (selectedCity) {
            if (this.addrObj.country == "CN") {
                this.addrObj.county = "";
            }
            this.hasCounties = true;
            this.cityList.forEach((item) => {
                if (item["cityid"] == selectedCity) {
                    this.selectedCity = item["cityname"];
                }
            });
            this.hasCounties = !!(this.countyList = this.countyListObj[this.addrObj.city]);
            // this.clearData(["county"]);
            if (this.hasCounties) {
                this.matchCityCounty(this.countyList, "county");
            }
            this.addrObj.address = this.getAddress();
            this.$emit("input", this.addrObj);
        },
        getCounty: function (selectedCounty) {
            this.countyList.forEach((item) => {
                if (item["countyid"] == selectedCounty) {
                    this.selectedCounty = item["countyname"];
                }
            });
            this.addrObj.address = this.getAddress();
            this.$emit("input", this.addrObj);
        },
        getAddress: function () {
            var province = "";
            var city = "";

            this.provinceList.forEach((item) => {
                if (item["subitem"] == this.addrObj.province) {
                    province = item["subitemname"];
                }
            });
            this.cityList.forEach((item) => {
                if (item["cityid"] == this.addrObj.city) {
                    city = item["cityname"];
                }
            });
            return province + city + this.selectedCounty;
        },
        matchCityCounty: function (cityOrCountyList, cityOrCounty) {
            let matchFlag = false;
            //                if(!util.isEmpty(cityOrCountyList)){
            cityOrCountyList.forEach((cityOrCountyItem) => {
                if (cityOrCountyItem[cityOrCounty + "id"] === this.addrObj[cityOrCounty]) {
                    matchFlag = true;
                }
            });
            //                }
            //                if(!matchFlag){//没有匹配上则是存量客户
            //                    this.addrObj[cityOrCounty] = cityOrCountyList[0][cityOrCounty + "id"];
            //                    this.$emit("input",this.addrObj);
            //                }
        }
    }
};
</script>
<style scoped>
.required .mint-cell-text:before {
    content: "*";
    color: #ea4941;
}
.el-select {
    margin-right: 20px;
}
</style>
